import * as Yup from "yup";
import { getPatchOperations } from "../../../util/form";

export const adminHotelFormConfig = (
  id: string | undefined,
): FormConfig<HotelDTO> => {
  return {
    title: "hotel",
    lockedValues: [{ id: "id", value: id }],
    validationSchema: Yup.object({
      navn1: Yup.string().required("Påkrævet"),
      aflysUgeHotel: Yup.number()
        .typeError("Skal være tal")
        .required("Påkrævet")
        .min(0, "Minimum 0"),
      aflysUgeVærelse: Yup.number()
        .typeError("Skal være tal")
        .required("Påkrævet")
        .min(0, "Minimum 0"),
      eMail: Yup.string().email("Skal være gyldig email").nullable(),
    }),
    form: [
      {
        component: "textinput",
        id: "navn1",
        initialValue: "",
        label: "Navn",
        placeholder: "",
        isRequired: true,
      },
      {
        component: "textinput",
        id: "navn2",
        initialValue: "",
        label: "Navn 2",
        placeholder: "",
        isRequired: false,
      },
      {
        component: "textarea",
        id: "sted",
        rows: 4,
        initialValue: "",
        label: "Sted",
        placeholder: "",
        isRequired: false,
      },
      {
        component: "textinput",
        id: "tlfNr",
        initialValue: "",
        label: "Telefon",
        placeholder: "",
        isRequired: false,
      },
      {
        component: "textinput",
        id: "faxNr",
        initialValue: "",
        label: "Fax",
        placeholder: "",
        isRequired: false,
      },
      {
        component: "textinput",
        id: "attPerson",
        initialValue: "",
        label: "Kontaktperson",
        placeholder: "",
        isRequired: false,
      },
      {
        component: "textinput",
        id: "eMail",
        initialValue: "",
        label: "Email",
        placeholder: "",
        isRequired: false,
      },
      {
        component: "textinput",
        id: "webAdresse",
        initialValue: "",
        label: "Web adresse",
        placeholder: "",
        isRequired: false,
      },
      {
        component: "textinput",
        id: "aflysUgeHotel",
        initialValue: "0",
        label: "Aflys uge hotel",
        placeholder: "",
        isRequired: true,
      },
      {
        component: "textinput",
        id: "aflysUgeVærelse",
        initialValue: "0",
        label: "Aflys uge værelse",
        placeholder: "",
        isRequired: true,
      },
    ],
    get: `hotel/${id}`,
    post(values) {
      return {
        query: `hotel`,
        body: values,
      };
    },
    patch(values) {
      return {
        query: `hotel/${id}`,
        body: JSON.stringify(getPatchOperations(values)),
      };
    },
    delete() {
      return {
        query: `hotel/${id}`,
      };
    },
    errorStatusCodeMessages: {
      409: "Hotellet kan ikke slettes, da det har reference til kurser",
    },
  };
};
